import React, { useEffect } from "react";
import DataTable from "../../DataTable/DataTable";
import { ProductHeaderArr } from "../../../Assets/api";
import { HeadingTitle } from "../ModalContainer";
import { useDispatch, useSelector } from "react-redux";
import { GetSKUProductsActions } from "../../../Actions/ProductionActions";
import Loading from "../../Loading/Loading";
import NoData from "../../Loading/NoData";
import secureLocalStorage from "react-secure-storage";

const Products = ({ close, inventory_id, box_id }) => {
  const dispatch = useDispatch();
  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;

  // Get SKU Products state
  const { SKU_products, loading } = useSelector((state) => state.products);

  // console.log("INVENTORY ID: ", inventory_id, box_id);

  useEffect(() => {
    if (inventory_id && box_id) {
      dispatch(
        GetSKUProductsActions(
          "inventory_get_box_products",
          inventory_id,
          box_id,
          token
        )
      );
    }
  }, [dispatch, inventory_id, box_id, token]);

  // console.log("SKU PRODUCTS: ", SKU_products);
  return (
    <>
      <HeadingTitle title={"View SKU"} center={false} closeModal={close} />
      <div className="inventory-wrapper">
        {SKU_products && SKU_products?.data?.length > 0 ? (
          <div className="table-wrapper-pagination">
            <div className="table-container-pagination">
              {loading ? (
                <Loading
                  loading={loading}
                  color={"rgba(1, 18, 34, 1)"}
                  size={42}
                />
              ) : (
                <>
                  <DataTable
                    items_per_page={10}
                    page={1}
                    header={ProductHeaderArr}
                    products={SKU_products && SKU_products?.data}
                  />
                </>
              )}
            </div>
          </div>
        ) : (
          <NoData title={"No SKU Found For this Box"} />
        )}
      </div>
    </>
  );
};

export default Products;
